document.addEventListener('DOMContentLoaded', () => {
    let totalSelectedCount = 0;
    window.selectedBundleProducts = [];
    window.product_quantity = 1;
    const popUpContainer = document.querySelector(".bundle-products-container-popup");


    const getSelectedVariantID = () => {
        const i = location.href.indexOf('?variant=');
        if(i != -1) {
            const id = location.href.substring(i + 9);
            return id;
        }
        return '';
    }
    if (popUpContainer) {
        const cardContainer = popUpContainer.querySelector(".bundle-products-body .main");
        const popUpHeader = popUpContainer.querySelector('.bundle-products-header');
        const productForm = document.querySelector("[data-form-wrapper] product-form");
        const selectedItemsButton = popUpContainer.querySelector('.select-items');
        const addCharmsButton = popUpContainer.querySelector(".btn-add-charms");
        const bundleProductsContainer = popUpContainer.querySelector(".bundle-products-container");
        const selectedBundleProductsContainer = popUpContainer.querySelector(".selected-bundle-products-container");
        const originalState = [];


        bundleProductsContainer.style.right = '-' + getComputedStyle(bundleProductsContainer).width;
        let selectedVariantID = productForm.querySelector("input[name='id']")?.value;
        if(!selectedVariantID) {
            selectedVariantID = getSelectedVariantID();
        }
        selectedBundleProducts.push({v_id: selectedVariantID});

        const hidePopup = () => {
            bundleProductsContainer.style.right = `-${bundleProductsContainer.offsetWidth}px`;
            const hTime = setInterval(() => {
                clearInterval(hTime);
                popUpContainer.classList.add('hide');
                document.documentElement.style.overflow = 'scroll';
                if(totalSelectedCount > 0) {
                    selectedBundleProductsContainer.classList.remove('hide');
                }
            }, 600);
        }
        const getOriginalState = () => {
            originalState.splice(0,originalState.length);
            popUpContainer.querySelectorAll(".bundle-product-card input[type='checkbox']:checked").forEach(item =>{
                originalState.push(item);
            });
        }
        const retrieveOriginalState = () => {
            selectedBundleProducts.splice(1, totalSelectedCount);
            totalSelectedCount = originalState.length;
            popUpContainer.querySelectorAll(".bundle-product-card input[type='checkbox']").forEach(item=>{
                item.checked = false;
            });
            originalState.forEach(item=>{
                item.checked = true;
                selectedBundleProducts.push({
                    p_id:item.closest(".bundle-product-card").getAttribute('product_id'),
                    v_id:item.closest(".bundle-product-card").getAttribute('variant_id')
                });
            });
            selectedItemsButton.innerHTML = `SELECT ${totalSelectedCount} ITEMS`;
        }
        const removeSelectedProduct = (index) => {
            selectedBundleProducts.splice(index, 1);
            totalSelectedCount --;
            selectedItemsButton.innerHTML = 'SELECT ' + totalSelectedCount + ' ITEMS';
        }
        popUpContainer.querySelector(".bundle-products-header svg").addEventListener('click', function () {
            hidePopup();
            retrieveOriginalState();
        });
        popUpContainer.querySelector('.overlay').addEventListener('click', () => {
            hidePopup();
            retrieveOriginalState();
        });
        popUpContainer.querySelector('.load-more')?.addEventListener('click', function () {
            if(this.classList.contains('back-to-top')) {
                let step = cardContainer.scrollTop / 100;
                if(step < 60) {
                    step = 60;
                }
                let hTime = setInterval(()=>{
                    if(cardContainer.scrollTop <= 0) {
                        clearInterval(hTime);
                        return;
                    }
                    cardContainer.scrollTo({
                        top: cardContainer.scrollTop - step
                    });
                },10);
            } else {
                popUpContainer.querySelectorAll(".bundle-product-card.hide").forEach(item => {
                    item.classList.remove('hide');
                });
                this.classList.add('back-to-top');
                this.innerHTML = 'BACK TO TOP';
            }
        });
        popUpContainer.querySelectorAll(".bundle-product-card input[type='checkbox']").forEach(item => {
            item.addEventListener('change', function () {
                if (this.checked) {
                    totalSelectedCount++;
                    selectedBundleProducts.push({ p_id: this.closest('.bundle-product-card').getAttribute('product_id'), v_id: this.closest('.bundle-product-card').getAttribute('variant_id') });
                } else {
                    for (const [index, selectedProduct] of selectedBundleProducts.entries()) {
                        if (selectedProduct.p_id === this.closest('.bundle-product-card').getAttribute('product_id')) {
                            removeSelectedProduct(index);
                            break;
                        }
                    }
                }
                selectedItemsButton.innerHTML = `SELECT ${totalSelectedCount} ITEMS`;
            });
        });
        selectedItemsButton.addEventListener('click', function () {
            let totalPrice = 0;
            productForm.querySelectorAll(".selected-bundle-product-card").forEach(item=>{
                item.classList.add('hide');
            });
            selectedBundleProducts.forEach((item,index) => {
                if(index > 0) {
                    const selectedProduct = productForm.querySelector(`.selected-bundle-product-card[product_id='${item.p_id}']`);
                    selectedProduct?.classList.remove('hide');
                    const price = parseInt(selectedProduct?.getAttribute('product_price'));
                    if(!isNaN(price)) {
                        totalPrice += price;
                    }
                }
            });
            const priceShowCtrl = addCharmsButton.querySelector(".title");
            if(totalPrice > 0) {
                priceShowCtrl.innerHTML = `${priceShowCtrl.getAttribute('text')}(+${window.sgcr_localization.country.currency.symbol}${(totalPrice / 100).toFixed(2)})`;
            } else {
                priceShowCtrl.innerHTML = `${priceShowCtrl.getAttribute('text')}`;
            }
            hidePopup();
            if (selectedBundleProducts.length > 1) {
                addCharmsButton.querySelector('.add_text').innerHTML = 'EDIT';
                selectedBundleProductsContainer.classList.remove('hide');
            } else {
                addCharmsButton.querySelector('.add_text').innerHTML = 'ADD';
                selectedBundleProductsContainer.classList.add('hide');
            }
        });
        cardContainer.addEventListener('scroll', function (e) {
            popUpHeader.classList.add('shadow');
            let hTime = setInterval(() => {
                clearInterval(hTime);
                popUpHeader.classList.remove('shadow');
            }, 100);
        });
        cardContainer.addEventListener('scrollend', function (e) {
            popUpHeader.classList.remove('shadow');
        });
        selectedBundleProductsContainer.querySelectorAll(".remove_button").forEach(item => {
            item.addEventListener('click', function () {
                const selectedBundleProduct = this.closest(".selected-bundle-product-card");
                selectedBundleProduct.classList.add('hide');
                popUpContainer.querySelector(`.bundle-product-card[product_id='${selectedBundleProduct.getAttribute('product_id')}']`).querySelector("input[type='checkbox']").checked = false;
                for (const [index,item] of selectedBundleProducts.entries()) {
                    if(item.p_id === selectedBundleProduct.getAttribute('product_id')) {
                        removeSelectedProduct(index);
                        break;
                    }
                }
                let totalPrice = 0;
                selectedBundleProductsContainer.querySelectorAll('.selected-bundle-product-card').forEach(item=>{
                    if(!item.classList.contains('hide')) {
                        const price = parseInt(item.getAttribute('product_price'));
                        if(!isNaN(price)) {
                            totalPrice += price;
                        }
                    }
                });
                const priceShowCtrl = addCharmsButton.querySelector(".title");
                if(totalPrice > 0) {
                    priceShowCtrl.innerHTML = `${priceShowCtrl.getAttribute('text')}(+${window.sgcr_localization.country.currency.symbol}${(totalPrice / 100).toFixed(2)})`;
                } else {
                    priceShowCtrl.innerHTML = `${priceShowCtrl.getAttribute('text')}`;
                }

                if (selectedBundleProducts.length > 1) {
                    addCharmsButton.querySelector('.add_text').innerHTML = 'EDIT';
                    selectedBundleProductsContainer.classList.remove('hide');
                } else {
                    addCharmsButton.querySelector('.add_text').innerHTML = 'ADD';
                    selectedBundleProductsContainer.classList.add('hide');
                }
            });
        });
        const insertChamrsContainerIntoProductForm = () => {
            const charmsContainer = popUpContainer.querySelector(".chamrs-container");
            addCharmsButton.addEventListener('click', function () {
                popUpContainer.classList.remove('hide');
                const hTime = setInterval(() => {
                    clearInterval(hTime);
                    bundleProductsContainer.style.right = '0px';
                }, 20);
                document.documentElement.style.overflow = 'hidden';
                selectedBundleProductsContainer.classList.add('hide');
                getOriginalState();
            });
            const addToCartButtonContainer = productForm.querySelector(".select__fieldset");
            charmsContainer.remove();
            if(addToCartButtonContainer) {
                productForm.insertBefore(charmsContainer,addToCartButtonContainer);
            } else {
                productForm.prepend(charmsContainer);
            }
            charmsContainer.classList.remove('hide');
        }
        const changeQuantity = () => {
            productForm.querySelectorAll('.select-popout__item').forEach(item=>{
                item.addEventListener('click',function(){
                    const quantity = parseInt(this.querySelector('.select-popout__option').getAttribute('data-value'));
                    console.log(quantity);
                    if(quantity === 10) {
                        productForm.querySelector('.quantity__input').addEventListener('change',function(){
                            window.product_quantity = parseInt(this.value);
                        });
                        productForm.querySelector('.quantity__plus').addEventListener('click',function(){
                            window.product_quantity ++;
                        });
                        productForm.querySelector('.quantity__minus').addEventListener('click',function(){
                            window.product_quantity --;
                        });
                    }
                    window.product_quantity = quantity;
                });
            });
        }
        insertChamrsContainerIntoProductForm();
        changeQuantity();
    }
});